export const TITLE = "Premium";

export const DESCRIPTION =
  "Power Words include student-friendly definitions " +
  "to help students expand their vocabulary.";
